import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { LiquidityGaugeControllerFactory } from "../codegen/LiquidityGaugeControllerFactory";
import { LiquidityGaugeControllerAddress } from "../constants/constants";
import { useWeb3Context } from "./web3Context";
export var getLiquidityGaugeController = function (library, useSigner) {
    if (useSigner === void 0) { useSigner = true; }
    var provider = useSigner ? library.getSigner() : library;
    return LiquidityGaugeControllerFactory.connect(LiquidityGaugeControllerAddress, provider);
};
var useLiquidityGaugeController = function () {
    var _a = useWeb3React(), active = _a.active, library = _a.library;
    var provider = useWeb3Context().provider;
    var _b = useState(null), contract = _b[0], setContract = _b[1];
    useEffect(function () {
        if (provider) {
            setContract(getLiquidityGaugeController(library || provider, active));
        }
    }, [provider, active, library]);
    return contract;
};
export default useLiquidityGaugeController;
//# sourceMappingURL=useLiquidityGaugeController.js.map